import React, {useEffect} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, withStyles} from '@material-ui/styles';
import { AppBar, Toolbar, 
  // Badge, 
  Typography,
  Hidden, IconButton,
  Divider,
} from '@material-ui/core';

import LogoutIcon from '@mui/icons-material/Logout';
import ReorderIcon from '@material-ui/icons/Reorder';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {useSelector} from 'react-redux';

import { doLogout,updatePlayWakeup } from 'actions/user.js';
import { VERSION_CONFIG } from 'version.js';

import {USERAUTH_ADMIN, SIREN_COLOR, CONFIG_SETTINGS} from "config.js";

import { FormattedMessage, useIntl } from "react-intl";
import LangChangeForm from './LangChangeForm';


const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",
  }
})(Typography);

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    // backgroundColor: theme.palette.white,
    // color: theme.palette.black,
    // color: "#FFFFFF",
    // backgroundColor: "#F4623A",
    backgroundColor: theme.palette.siren_symbol.main,
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  divider:{
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },


  disable_play_btn: {
    backgroundColor: SIREN_COLOR.ABSENCE_BG2_COLOR,
  },
}));



const Topbar = props => {
  const { className, onSidebarOpen, openSidebar, doLogout, user, ...rest } = props;

  const userAuth = useSelector((state) => state.user.admin_type);
  // const selector_play_wakeup = useSelector((state) => state.envSettings.play_wakeup);

  const classes = useStyles();
  const {formatMessage} = useIntl();

  // const [notifications] = useState([]);

  const handleLogout = event => {
    props.doLogout();
    window.location.href = '/sign-in';
  }


  const handleAudioPause = event => {
    localStorage.setItem(CONFIG_SETTINGS.PLAY_WAKEUP_ALARM, false);
    localStorage.setItem(CONFIG_SETTINGS.PLAY_EMERGENCY_ALARM, false);
    props.updatePlayWakeup(0)
  }

  // useEffect(()=>{
  //   console.log('selector_play_wakeup: '+ selector_play_wakeup);
  // },[selector_play_wakeup]);


  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar>

        <IconButton onClick={onSidebarOpen} style={{color: "#FFF"}}>
          {!openSidebar ? <ReorderIcon /> : null}
        </IconButton>


        <div style={{ paddingLeft: "10px", display: 'flex', alignItems: 'center'}}>
          <WhiteTextTypography variant="h4">
            SirenCare Dashboard
          </WhiteTextTypography>

          <div style={{ paddingLeft: "5px" }}>
            <WhiteTextTypography variant="caption">
              ver:{VERSION_CONFIG.RELEASE_NO}
            </WhiteTextTypography>
          </div>
        </div>



        <div className={classes.flexGrow} />


        <IconButton
          className={classes.signOutButton}
          // className={classes.disable_play_btn}
          color="inherit"
          onClick={handleAudioPause}
          // defaultMessage="Pause"
          size="medium"
          // disabled={!selector_play_wakeup}
        >
            <NotificationsOffIcon variant="rounded" fontSize="large"  />
        </IconButton>


        <Divider className={classes.divider}  orientation="vertical" variant="fullWidth" flexItem />


        <div style={{ paddingLeft: "10px", paddingRight: "10px", display: 'flex', alignItems: 'center'}}>

          <WhiteTextTypography variant="h5">
            [
            {userAuth === USERAUTH_ADMIN ? ( formatMessage({id:'super_admin'}) ):( formatMessage({id:'general_admin'}) )}
            ]
          </WhiteTextTypography>

          <div style={{ paddingLeft: "10px" }}>
            <WhiteTextTypography variant="h4">
              {user.facility_name}
            </WhiteTextTypography>
          </div>
        </div>


        <Divider className={classes.divider}  orientation="vertical" variant="fullWidth" flexItem />

        <div style={{marginLeft:16, marginRight:16}}>
          <LangChangeForm/>
        </div>

        <Divider className={classes.divider}  orientation="vertical" variant="fullWidth" flexItem />

        <IconButton
          className={classes.signOutButton}
          color="inherit"
          onClick={handleLogout}
          // defaultMessage="Log out"
          size="medium"
        >
          <LogoutIcon />
        </IconButton>

      </Toolbar>
    </AppBar>
  );
};


Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({ doLogout, updatePlayWakeup }, dispatch)
}

let mapStateToProps = (state) => {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Topbar);
